import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import "./Tab.css";

function Tab(props) {
  const [tabs, setTabs] = useState([]);
  const [selectTab, setSelectTab] = useState(0);


  useEffect(() => {
    if (props.location.state && ['user_module', 'league_module'].includes(props.type)) {
      setSelectTab(props.location.state.selectedTab || 0);
    }
    if (props.tabs) {
      selectedTab();
      setTabs(props.tabs);
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (props.location.search) {
      if (props.location.search.includes('selected')) {
        selectedTab();
      }
    }
    // eslint-disable-next-line
  }, [props.location])

  const selectedTab = () => {
    let selected_tab = props.location.pathname.split('/').pop();
    if (selected_tab && props.tabs.length) {
      selected_tab = `/${selected_tab}`;
      const idx = props.tabs.findIndex(tab => {
        return tab.url === selected_tab;
      })
      if (idx > -1) {
        setSelectTab(selected_tab);

      } else {
        selected_tab = props.tabs[0].url;
        setSelectTab(selected_tab);
      }
    }
  }

  return (
    <div className="tabs-container ls-tabs-container">
      <div className="tabs-wrapper">
        <div className="tabs-innerWrapper">
          {tabs &&
            tabs.length > 0 ?
            (() => {
              return tabs.map((tab, index) => {
                return (
                  <Link
                    to={{
                      pathname: `${props.match.url}${!props.disable ? tab.url.toLowerCase() : ''}`,
                      search: tab && tab.search ? tab.search : '',
                    }}
                    key={`link-tabs-${index}`}
                    className={(tab.url === selectTab) ? 'active' : ''}
                    onClick={() => {
                      setSelectTab(tab.url);
                      if (props.emit) {
                        props.emit(tab.url);
                      }
                    }}>
                    {tab.name}
                  </Link>
                )
              });
            })() : ''}
        </div>
      </div>
    </div>
  );
}

export default withRouter(Tab);
